import React from "react";
import type { Step } from "../../types/content";
import { SectionHeading } from "./SectionHeading";
type StepListProps = {
  id: string;
  eyebrow: string;
  title: string;
  intro?: string;
  steps: Step[];
  background?: "white" | "soft";
};
const columnClasses: Record<number, string> = {
  3: "sm:grid-cols-3",
  4: "sm:grid-cols-2 lg:grid-cols-4",
  5: "lg:grid-cols-5"
};
export function StepList({
  id,
  eyebrow,
  title,
  intro,
  steps,
  background = "white"
}: StepListProps) {
  return <section className={`${background === "soft" ? "bg-soft" : "bg-white"} py-8 lg:py-14`} aria-labelledby={id} data-id="element-269" data-mp="1dmnoxqfnun76">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-10" data-id="element-270" data-mp="znek1mwwnfii">
        <SectionHeading id={id} eyebrow={eyebrow} title={title} intro={intro} data-id="element-271" data-mp="14lg2q6qf5ctg" />
        <ol className={`mt-10 grid auto-rows-fr gap-px overflow-hidden rounded-lg border border-line bg-line ${columnClasses[steps.length] ?? "lg:grid-cols-4"}`} data-id="element-272" data-mp="14nk5glcl05s5">
          {steps.map((step, index) => <li key={step.title} className="flex flex-col bg-white p-6" data-id="element-273" data-mp="2yx4l6ivuzxil" data-mpi={index}>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-rinnai text-sm font-bold text-white" aria-hidden="true" data-id="element-274" data-mp="pgluj3j3mbnd">{index + 1}</span>
              <h3 className="mt-5 font-bold text-ink" data-id="element-275" data-mp="yaqjfheo9d09">{step.title}</h3>
              <p className="mt-2 text-sm leading-6 text-muted" data-id="element-276" data-mp="u8viwf4kf3nj">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}